import { render } from "./wfm-progress-loader.vue?vue&type=template&id=167480b2"
import script from "./wfm-progress-loader.vue?vue&type=script&lang=js"
export * from "./wfm-progress-loader.vue?vue&type=script&lang=js"

import "./wfm-progress-loader.vue?vue&type=style&index=0&id=167480b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__